// extracted by mini-css-extract-plugin
export var equalColumn = "_h3-0";